import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect, useState } from "react";
import HoverImage from "react-hover-image/build";
import { ModuleAccess } from "utils/moduleaccess";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { cellRendererCheck, dateFormate } from "utils/columns";
import Maping from "assets/icon/MapIcon.svg";
import MapHover from "assets/icon/MapIconHover.svg";
import UnMapped from "assets/icon/UnMapped.svg";
import Loader from "components/Loader";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import { cloneDeep } from "lodash";
import save from "assets/icon/save.svg";

const UnMappedNDCTable = (props) => {
  const {
    unmapedChargeCount,
    manvalConfigedit,
    manvalConfig,
    manvalPharmacy,
    onSearchColumnFilters = () => "",
    data,
    totalSize,
    unmapedNdcCount,
    filters,
    orgId,
    onPageChange,
    searchTerms,
    search,
    onExport,
    onclick,
    refetch,
    load,
    toggleSider,
    collapseSider,
    setNdcMapingFlag,
    ndcmapingflag,
    selectedRow,
    setselectedRow,
    resetFilterFlag,
    SetResetFilterFlag,
    Ndcflag,
    setNdcflag,
    loading,
    setLoding,
    crosswalkNdcsearch,
    NdcTotalrecords,
    NdcTableData,
    setNdcPurchaseHistoryData,
    setNDCMapingHistoryData,
    setndcDetails,
    setLoading,
    NdccolumnFilters,
    ndcPurchaseHistoryRecords,
    setNdcPurchaseHistoryRecords,
    selectedndcpurchaseData,
    setSelectedNdcPurchaseData,
    MapingHistoryinstialValues,
  } = props;
  const API = useAxios();
  const [isOpen, setIsOpen] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [selectedrow, setSelectedRow] = useState({});
  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 117,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },

    {
      dataField: "ndc",
      text: "NDC",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "drugDescription",
      text: "NDC Description",
      sort: true,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.drugDescription),
    },
    {
      dataField: "packageSize",
      text: "Package Size",
      sort: true,
      width: 110,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.packageSize),
    },
    {
      dataField: "unitOfMeasure",
      text: "UOM",
      sort: true,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.unitOfMeasure),
    },
    {
      dataField: "gcnSequenceNumber",
      text: "GCN",
      sort: true,
      width: 80,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.gcnSequenceNumber),
    },
    {
      dataField: "lastInvoicedDate",
      text: "Last Invoiced Date",
      sort: true,
      width: 140,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row, col) => dateFormate(row.lastInvoicedDate),
    },
    {
      dataField: "lastInvoicedQty",
      text: "Last Invoiced Qty",
      sort: true,
      width: 137,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.lastInvoicedQty),
    },
    // {
    //   dataField: "modifiedby",
    //   text: "Last Invoice #",
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: "number",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck("104577"),
    // },
    // {
    //   dataField: "responsiveflag",
    //   text: "Account #",
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: "text",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck("124578"),
    // },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 150,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },
  ];


useEffect(()=>{
   setNdcflag(false);
   setIsOpen(false);
},[orgId])


  const togglemapingview = (rowData) => {
    debugger;
    setndcDetails(rowData);
    setNdcflag(true);
    handleMap(rowData);
  };
  const handleMap = async (rowData) => {
    debugger;
    fetchmapingHistory(rowData);
    fetchPurchaseHistory(rowData);
  };
  const fetchmapingHistory = async (rowData) => {
    debugger;
    let ndc = rowData?.ndc
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId?.tenantID}/Crosswalk/NdcMappingHistory/${ndc}`, crosswalkNdcsearch,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setNDCMapingHistoryData(data.items);
        //setLoading(false);
      }
      else {
        setNDCMapingHistoryData([]);
        // setLoading(false);
      }
    } catch {
      // setLoading(false);
    }
  };
  const fetchPurchaseHistory = async (rowData) => {
    setSelectedNdcPurchaseData(rowData)
    let ndc = rowData?.ndc;
    //setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId?.tenantID}/Crosswalk/NDCItemHistory/${ndc}`,
        MapingHistoryinstialValues,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setNdcPurchaseHistoryData(data.items);
        setNdcPurchaseHistoryRecords(data.totalRecords);
        setLoading(false);
      } else {
        setLoading(false);
        setNdcPurchaseHistoryData([]);
        setNdcPurchaseHistoryRecords(0);
      }
    } catch {
      setLoading(false);
    }
  };

  const hasPermission = (code) => {
        return ModuleAccess("CRW", code);
      };

  const renderMapping = (rowData) => {
    if (hasPermission("HI"))
    if (rowData.isEdit != true)
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => togglemapingview(rowData)}
          title="Map"
        >
          <HoverImage key="Maping" src={Maping} hoverSrc={MapHover} alt="" />
        </Button>
      );
  };
  const toggleHide = (rowData) => {
    debugger;
    // console.log(rowData,"rowdata")
    setSelectedRow(rowData);
    handelToggle();
  };
  const handelChecked = () => {
    setIsCheck(!isCheck);
  };
  const renderUnMapped = (rowData) => {
    if (hasPermission("HD")) {
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleHide(rowData)}
          title="Hide"
        >
          <HoverImage key="Maping" src={UnMapped} hoverSrc={UnMapped} alt="" />
        </Button>
      );
    }
  };
  const cellRenderEdit = (rowData) => {
    if (rowData.mapingStatus != "Historicalmappings")
      return (
        <div className="d-flex align-items-center">
          {renderMapping(rowData)}
          {renderUnMapped(rowData)}
        </div>
      );
  };
  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleFilterCancel = () => {
    refetch(true);
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
    }
  };
  const handelToggle = () => {
    setIsCheck(false);
    setIsOpen(!isOpen);
  };
  const handelUnHideNdc = async (rowData, status) => {
    setLoading(true);
    let orderDrugID = rowData.orderDrugID;

    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/CrossWalk/HiddenAndUnHiddenNDC/${orderDrugID}/${status}/${isCheck}`,

        { hasDefaultURL: true }
      );
      if (data.error == false) {
        // setHiddenTableData(data.items);
        // setTotalHideRecords(data.totalRecords);
        setLoading(false);
        toast.success(data.message);
        handelToggle();
        refetch(true);
      } else {
        // setHiddenTableData([]);
        // setTotalHideRecords(0);
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };
  const handelSubmit = () => {
    handelUnHideNdc(selectedrow, "hide");
  };
  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(crosswalkNdcsearch);
    if (NdccolumnFilters && NdccolumnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...NdccolumnFilters];
    }
    const { access_token } =
      JSON.parse(localStorage.getItem("pharmaforce")) || {};
    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID;
    payload.gridCode = "crosswalkunmappedndc";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };
  return (
    <div>
      {/* {loading && <Loader opacity={0.01} />} */}

      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={NdcTableData?.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="unmappedndc-table"
          height={550}
          fixedColumn
          width={1200}
          hasPagination
          // reset={reset}
          data={NdcTableData}
          columns={mainCol}
          onExport={handleExport}
          filters={crosswalkNdcsearch}
          totalRecords={NdcTotalrecords}
          pageSize={crosswalkNdcsearch.pageSize}
          currentPage={crosswalkNdcsearch.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          toggleSider={toggleSider}
          collapseSider={collapseSider}
          showtoggle={true}
          resetFilterFlag={resetFilterFlag}
          SetResetFilterFlag={SetResetFilterFlag}
          // hasExportPermission={hasExportPermission}
        />
      </div>
      <Modal isOpen={isOpen} toggle={handelToggle} size="lg" className="md">
        <ModalHeader toggle={handelToggle}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            NDC Order Exclusion
          </h5>
        </ModalHeader>
        <ModalBody className="m-2 p-2">
          <div>
            <p className="f-13 text-primary font-weight-600 mt-2">
              You have chosen to hide this NDC from the crosswalk. This action
              will hide this NDC from your unmapped NDC list and prevent mapping
              this NDC to a charge code.
            </p>
            <div className="d-flex justify-content-between">
              <Input
                type="checkbox"
                value={isCheck}
                onClick={handelChecked}
                style={{ border: "2px solid #dee2e6" }}
              />
               &nbsp;&nbsp;
              <p className="f-13 font-weight-600">
                Would you also like to add this NDC in the NDC Exclusion
                list? By adding the NDC to the exclusion list, all orders going
                forward will automatically split to the GPO account.
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            style={{ width: "160px" }}
            className="search"
            onClick={handelSubmit}
          >
            <span className="right_5">
              <img src={save} alt="" />
            </span>{" "}
            Apply & Save
          </Button>{" "}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default UnMappedNDCTable;
